import { render, staticRenderFns } from "./ModalPremiumInfo.vue?vue&type=template&id=2e842244&scoped=true"
import script from "./ModalPremiumInfo.vue?vue&type=script&lang=js"
export * from "./ModalPremiumInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalPremiumInfo.vue?vue&type=style&index=0&id=2e842244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e842244",
  null
  
)

export default component.exports